import CasefileDataService from "@/services/CasefileDataService";
// import moment from "moment"; // Remove unused import
import axios from "axios";
import { apiConfig } from "@/config/api.config";

// Major housekeeping: Remove unused getters, state, mutations, and actions.
// Only keep paginatedAll, paginatedPermitted, paginatedPermittedActive, paginatedPermittedArchive and their totals/loading/page/pageSize.

export default {
  namespaced: true,
  state: {
    paginatedAll: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 30,
      filters: {},
      isLoading: false,
    },
    paginatedPermitted: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 30,
      filters: {},
      isLoading: false,
    },
    paginatedPermittedActive: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 30,
      isLoading: false,
    },
    paginatedPermittedArchive: {
      data: [],
      total: 0,
      page: 1,
      pageSize: 30,
      isLoading: false,
    },
  },

  getters: {
    getPaginatedAll: (state) => state.paginatedAll.data,
    getPaginatedTotalAll: (state) => state.paginatedAll.total,

    getPaginatedPermitted: (state) => state.paginatedPermitted.data,
    getPaginatedTotalPermitted: (state) => state.paginatedPermitted.total,
    getPaginatedPermittedLoading: (state) => state.paginatedPermitted.isLoading,

    getPaginatedPermittedActive: (state) => state.paginatedPermittedActive.data,
    getPaginatedTotalPermittedActive: (state) =>
      state.paginatedPermittedActive.total,
    getPaginatedPermittedActiveLoading: (state) =>
      state.paginatedPermittedActive.isLoading,

    getPaginatedPermittedArchive: (state) =>
      state.paginatedPermittedArchive.data,
    getPaginatedTotalPermittedArchive: (state) =>
      state.paginatedPermittedArchive.total,
    getPaginatedPermittedArchiveLoading: (state) =>
      state.paginatedPermittedArchive.isLoading,

    getPaginatedPage: (state) => state.paginatedPermitted.page,
    getPaginatedPageSize: (state) => state.paginatedPermitted.pageSize,
    getPaginatedLoading: (state) => state.paginatedPermitted.isLoading,
  },

  mutations: {
    SET_PAGINATED_ALL(state, { data, total, page, pageSize, filters }) {
      state.paginatedAll.data = data;
      state.paginatedAll.total = total;
      state.paginatedAll.page = page;
      state.paginatedAll.pageSize = pageSize;
      state.paginatedAll.filters = filters || {};
    },
    SET_PAGINATED_ALL_LOADING(state, status) {
      state.paginatedAll.isLoading = status;
    },
    SET_PAGINATED_PERMITTED(state, { data, total, page, pageSize, filters }) {
      state.paginatedPermitted.data = data;
      state.paginatedPermitted.total = total;
      state.paginatedPermitted.page = page;
      state.paginatedPermitted.pageSize = pageSize;
      state.paginatedPermitted.filters = filters || {};
    },
    SET_PAGINATED_PERMITTED_LOADING(state, status) {
      state.paginatedPermitted.isLoading = status;
    },
    SET_PAGINATED_PERMITTED_ACTIVE(state, payload) {
      state.paginatedPermittedActive.data = payload.data || [];
      state.paginatedPermittedActive.total = payload.total || 0;
      state.paginatedPermittedActive.page = payload.page || 1;
      state.paginatedPermittedActive.pageSize = payload.pageSize || 30;
      state.paginatedPermittedActive.isLoading = false;
    },
    SET_PAGINATED_PERMITTED_ACTIVE_LOADING(state, isLoading) {
      state.paginatedPermittedActive.isLoading = isLoading;
    },
    SET_PAGINATED_PERMITTED_ARCHIVE(state, payload) {
      state.paginatedPermittedArchive.data = payload.data || [];
      state.paginatedPermittedArchive.total = payload.total || 0;
      state.paginatedPermittedArchive.page = payload.page || 1;
      state.paginatedPermittedArchive.pageSize = payload.pageSize || 30;
      state.paginatedPermittedArchive.isLoading = false;
    },
    SET_PAGINATED_PERMITTED_ARCHIVE_LOADING(state, isLoading) {
      state.paginatedPermittedArchive.isLoading = isLoading;
    },
    CLEAR_PAGINATED_CASEFILES(state) {
      state.paginatedAll = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        filters: {},
        isLoading: false,
      };
      state.paginatedPermitted = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        filters: {},
        isLoading: false,
      };
      state.paginatedPermittedActive = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        isLoading: false,
      };
      state.paginatedPermittedArchive = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        isLoading: false,
      };
    },
    CLEAR_PAGINATED_PERMITTED_ACTIVE(state) {
      state.paginatedPermittedActive = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        isLoading: false,
      };
    },
    CLEAR_PAGINATED_PERMITTED_ARCHIVE(state) {
      state.paginatedPermittedArchive = {
        data: [],
        total: 0,
        page: 1,
        pageSize: 30,
        isLoading: false,
      };
    },
  },

  actions: {
    async fetchPaginatedAll(
      { commit },
      { page = 1, pageSize = 30, filters = {} } = {}
    ) {
      commit("SET_PAGINATED_ALL_LOADING", true);
      try {
        const params = { page, pageSize, ...filters };
        const response = await CasefileDataService.getPaginated(params);
        commit("SET_PAGINATED_ALL", {
          data: response.data.data,
          total: response.data.total,
          page: response.data.page,
          pageSize: response.data.pageSize,
          filters,
        });
        return response;
      } catch (error) {
        console.error("Error fetching paginated all casefiles:", error);
        throw error;
      } finally {
        commit("SET_PAGINATED_ALL_LOADING", false);
      }
    },
    async fetchPaginatedPermitted(
      { commit, rootState },
      { page = 1, pageSize = 30, filters = {} } = {}
    ) {
      commit("SET_PAGINATED_PERMITTED_LOADING", true);
      try {
        const user = rootState.auth.user;
        if (!user) {
          commit("SET_PAGINATED_PERMITTED", {
            data: [],
            total: 0,
            page,
            pageSize,
            filters,
          });
          return;
        }
        const params = {
          ...filters,
          page,
          pageSize,
          roles: user.roles,
          dept: user.dept,
          branches: user.branches,
          userId: user.id,
        };
        const response = await CasefileDataService.getPaginated(params);
        commit("SET_PAGINATED_PERMITTED", {
          data: response.data.data,
          total: response.data.total,
          page: response.data.page,
          pageSize: response.data.pageSize,
          filters,
        });
      } catch (error) {
        console.error("Error fetching paginated permitted casefiles:", error);
        throw error;
      } finally {
        commit("SET_PAGINATED_PERMITTED_LOADING", false);
      }
    },
    async fetchPaginatedPermittedActive(
      { commit, rootState },
      payload // Accept all params as a single object
    ) {
      commit("SET_PAGINATED_PERMITTED_ACTIVE_LOADING", true);
      try {
        const user = rootState.auth.user;
        // Build params from payload (spread all top-level keys)
        const params = {
          ...payload,
        };
        if (user) {
          params.roles = user.roles;
          params.dept = user.dept;
          params.branches = user.branches;
          params.userId = user.id;
        }
        const res = await axios.get(
          `${apiConfig.baseURL}/casefiles/paginated-permitted-active`,
          {
            params,
          }
        );
        commit("SET_PAGINATED_PERMITTED_ACTIVE", {
          data: res.data.data,
          total: res.data.total,
          page: res.data.page,
          pageSize: res.data.pageSize,
        });
      } catch (e) {
        commit("SET_PAGINATED_PERMITTED_ACTIVE", {
          data: [],
          total: 0,
          page: 1,
          pageSize: payload.pageSize,
        });
      } finally {
        commit("SET_PAGINATED_PERMITTED_ACTIVE_LOADING", false);
      }
    },
    clearPaginatedPermittedActive({ commit }) {
      commit("CLEAR_PAGINATED_PERMITTED_ACTIVE");
    },
    async fetchPaginatedPermittedArchive(
      { commit, rootState },
      { page, pageSize, filters }
    ) {
      commit("SET_PAGINATED_PERMITTED_ARCHIVE_LOADING", true);
      try {
        const user = rootState.auth.user;
        const params = {
          ...filters,
          page,
          pageSize,
        };
        if (user) {
          params.roles = user.roles;
          params.dept = user.dept;
          params.branches = user.branches;
          params.userId = user.id;
        }
        const res = await axios.get(
          `${apiConfig.baseURL}/casefiles/paginated-permitted-closed`,
          {
            params,
          }
        );
        commit("SET_PAGINATED_PERMITTED_ARCHIVE", {
          data: res.data.data,
          total: res.data.total,
          page: res.data.page,
          pageSize: res.data.pageSize,
        });
      } catch (e) {
        commit("SET_PAGINATED_PERMITTED_ARCHIVE", {
          data: [],
          total: 0,
          page: 1,
          pageSize: pageSize,
        });
      } finally {
        commit("SET_PAGINATED_PERMITTED_ARCHIVE_LOADING", false);
      }
    },
    clearPaginatedPermittedArchive({ commit }) {
      commit("CLEAR_PAGINATED_PERMITTED_ARCHIVE");
    },
    clearPaginatedCasefiles({ commit }) {
      commit("CLEAR_PAGINATED_CASEFILES");
    },
  },
};
